var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.computedCategories,"label":"Type","hide-details":""},model:{value:(_vm.categoryId),callback:function ($$v) {_vm.categoryId=$$v},expression:"categoryId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }